<template>
    <!-- 判断题 -->
    <div class="itemConte" >
        <h5>{{itmData.questionindex}}.<span v-html="itmData.subject"></span>（{{itmData.questiontypename+'，'+itmData.quesscore}}分）</h5>
        <div class="resBox">
            <div class="res" v-for="(itm,idx) in judgeData" :key="idx">
                <el-radio v-model="itm.value" disabled :label="itmData.uselanswer" >{{itm.label}}</el-radio>
            </div>
        </div>
        <div class="resAns">
            <p>学员答案：{{itmData.uselanswer}}<span class="ans">答案{{itmData.answerstatus === 1 ? '正确':'错误'}}</span></p>
            <p>正确答案：{{itmData.finalanswer}}</p>
            <p v-if="itmData.quesanalysis" class="analysis">解析：<span v-html="itmData.quesanalysis"></span></p>
            <p v-else class="analysis">解析：暂无解析</p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['itmData'],
    data(){
        return {
            judgeData: [
                {label: '正确', value:  'T'},
                {label: '错误', value:  'F'}
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
</style>